const greyhoundInitialState = {
    greyhoundMarkets: [],
    greyhoundRaceList: []
};

export default greyhoundInitialState;
